module.exports = __webpack_public_path__ + "static/media/changelog.87cbaf83.webp";